import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import EyeIcon from '@material-ui/icons/Visibility';
import CorrectIcon from '@material-ui/icons/Done';
import IncorrectIcon from '@material-ui/icons/Clear';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles(theme =>  ({
  // theme: console.log(theme),
  wrapper: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& > div': {
      width: 700,
      maxWidth: '100%',
      background: '#fff',
      padding: 20,
      maxHeight: '100%',
      overflow: 'auto',
    },
    '& h3': {
      textAlign: 'center',
      color: theme.palette.primary.main,
      marginTop: 0,
    },
  },
  inputs: {
    width: '100%',
    margin: '0 auto',
    background: '#f1f1f1',
    '& input': {
      fontSize: '1em',
      width: '100%',
      border: 'none',
      background: 'none',
      outline: 'none !important',
      boxSizing: 'border-box',
      fontFamily: theme.typography.body1.fontFamily,
    },
    '& td': {
      '&:nth-child(1)': {
        width: '45%',
        background: '#c0dff1',
        padding: '0.25em 0.5em',
        textAlign: 'center',
      },
      '&:nth-child(2)': {
        width: '45%',
        background: '#c8f1c0',
        padding: '0.25em 0.5em',
      },
      '&:nth-child(3)': {
        width: '10%',
        textAlign: 'center',
      },
    },
  },
  eye: {
    color: '#f5a52d',
  },
  correct: {
    color: 'green',
  },
  incorrect: {
    color: 'red',
  },
  action: {
    textAlign: 'center',
    verticalAlign: 'middle',
    marginTop: 20,
    '& button': {
      margin: '0 3px',
      verticalAlign: 'middle',
    },
    '& > span': {
      display: 'inline-block',
      minWidth: 53,
      verticalAlign: 'middle',
      userSelect: 'none',
    },
  },
  '@media(max-width: 450px)': {

  }
}));

let previewTimeout = 0;
let active = true;
function Opposites(props) {
  const classes = useStyles();
  const [ finished, setFinished ] = useState(false);
  const [ answers, setAnswers ] = useState([]);
  const [ previews, setPreviews ] = useState([]);
  const [ result, setResult ] = useState([]);
  const [ showResult, setShowResult ] = useState(false);
  const { exercise, startStats, finishExercise, action, type, close } = props.exerciseProps;

  useEffect(() => {
    init();
    return () => {
      clearTimeout(previewTimeout);
    }
    // eslint-disable-next-line
  }, []);

  const init = () => {
    active = true;
    startStats(type);
    setFinished(false);
    setAnswers(exercise.map(words => words.word2.substr(0, 1)));
    setPreviews(exercise.map(_ => false));
    setResult(exercise.map(_ => false));
  }

  const incorrect = () => {
    props.media.failure();
    active = false;
    previewTimeout = setTimeout(() => {
      setShowResult(false);
      active = true;
    }, 1500);
  }

  const finish = () => {
    finishExercise();
    setFinished(true);
    props.media.finish();
  }

  const setAnswer = (idx, ev) => {
    const val = ev.target.value;
    const newAnswers = [ ...answers ];
    newAnswers[idx] = val;
    setAnswers(newAnswers);
  }

  const checkAnswers = () => {
    const ans = exercise.map(_ => false);
    answers.forEach((answer, idx) => {
      if (answer === exercise[idx].word2) {
        ans[idx] = true;
      }
    });
    setResult(ans);
    setShowResult(true);
    const allOk = ans.reduce((result, current) => !current ? false : result, true);
    if (allOk) {
      finish();
    } else {
      incorrect();
    }
  }

  const preview = (idx) => {
    action();
    if (!active) return;
    active = false;
    const newPreviews = [ ...previews ];
    newPreviews[idx] = true;
    setPreviews(newPreviews);
    previewTimeout = setTimeout(() => {
      active = true;
      setPreviews(exercise.map(_ => false));
    }, 1500);
  }

  if (answers.length === 0) return '';

  return (
    <div className={classes.wrapper}>
      <div>
        <h3>Wpisz wyraz o przeciwnym znaczeniu</h3>
        <table className={classes.inputs}>
          <tbody>
            {exercise.map((words, idx) => <tr key={idx}>
              <td>{words.word1}</td>
              {!previews[idx] && <td><input 
                type='text'
                value={answers[idx]}
                onChange={ev => setAnswer(idx, ev)}
                autoCorrect="off"
                autoCapitalize="none"
                spellCheck={false}
                tabIndex={idx + 1}
              /></td>}
              {previews[idx] && <td>{words.word2}</td>}
              <td>
                {!previews[idx] && !showResult && <IconButton onClick={() => preview(idx)} tabIndex="-1"><EyeIcon className={classes.eye}/></IconButton>}
                {previews[idx] && <IconButton tabIndex="0-1"><EyeIcon /></IconButton>}
                {showResult && result[idx] && <IconButton tabIndex="-1"><CorrectIcon className={classes.correct}/></IconButton>}
                {showResult && !result[idx] && <IconButton tabIndex="-1"><IncorrectIcon className={classes.incorrect}/></IconButton>}
              </td>
            </tr>)}
          </tbody>
        </table>
        <div className={classes.action}>
       {!finished && <Button variant="outlined" color="secondary" onClick={checkAnswers} tabIndex={6}>Sprawdź</Button>}
       {finished && <Button variant="outlined" color="secondary" onClick={close} tabIndex={1}>Zamknij</Button>}
     </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return { 
    media: state.media,
    mobile: state.mobile,
  }
}

export default connect(mapStateToProps)(Opposites);